import { type ReactElement } from 'react';
import {
  tableV2ActionsColumnWidth,
  tableV2ChevronColumnWidth,
} from '@/features/shared/components/tableSystem/TableV2Primitives';
import type { MetricThresholdGroupKey } from '@/shared/utils/metricsThresholds';

type TestingEntityMetricColumnWidths = {
  name: number;
  status: number;
  dateTime: number;
  metric: number;
  tags: number;
};

const testingEntityMetricColumnWidthsByCount = {
  0: { name: 38, status: 16, dateTime: 20, metric: 0, tags: 23 },
  1: { name: 36, status: 14, dateTime: 18, metric: 12, tags: 17 },
  2: { name: 34, status: 13, dateTime: 17, metric: 11, tags: 11 },
  3: { name: 30, status: 12, dateTime: 15, metric: 10, tags: 10 },
  4: { name: 24, status: 10, dateTime: 13, metric: 10, tags: 10 },
} satisfies Record<number, TestingEntityMetricColumnWidths>;

const resolveTestingEntityMetricColumnWidths = (
  visibleMetricCount: number,
): TestingEntityMetricColumnWidths => {
  switch (visibleMetricCount) {
    case 0:
      return testingEntityMetricColumnWidthsByCount[0];
    case 1:
      return testingEntityMetricColumnWidthsByCount[1];
    case 2:
      return testingEntityMetricColumnWidthsByCount[2];
    case 3:
      return testingEntityMetricColumnWidthsByCount[3];
    case 4:
    default:
      return testingEntityMetricColumnWidthsByCount[4];
  }
};

export const buildTestingEntityMetricColgroup = (
  visibleMetricKeys: MetricThresholdGroupKey[],
): ReactElement => {
  const widths = resolveTestingEntityMetricColumnWidths(visibleMetricKeys.length);

  return (
    <colgroup>
      <col width={tableV2ChevronColumnWidth} />
      <col width={`${String(widths.name)}%`} />
      <col width={`${String(widths.status)}%`} />
      <col width={`${String(widths.dateTime)}%`} />
      {visibleMetricKeys.map((key) => (
        <col key={key} width={`${String(widths.metric)}%`} />
      ))}
      <col width={`${String(widths.tags)}%`} />
      <col width={tableV2ActionsColumnWidth} />
    </colgroup>
  );
};
